import script from "./Accident.vue?vue&type=script&setup=true&lang=js"
export * from "./Accident.vue?vue&type=script&setup=true&lang=js"

import "./Accident.vue?vue&type=style&index=0&id=31f82723&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31f82723"]])

export default __exports__